import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M12 7.77L18.39 18H5.61L12 7.77M12 4L2 20h20L12 4z"
}), 'ChangeHistoryOutlined');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/ChangeHistoryOutlined.js
// module id = 2734
// module chunks = 2